import Typography from "@mui/material/Typography";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import type { AnchorInfo, PublicationItemInfo } from "./useTaskDetailSubscription";
import type { PreviewSibling } from "./useTaskDetailActions";
import { IfPermission } from "../../auth/IfPermission";
import { ArticleBand } from "./ArticleBand";
import { SentenceBand } from "./SentenceBand";

export function AnchorRow(props: {
  anchor: AnchorInfo;
  isHomepage: boolean;
  publicationItems: PublicationItemInfo[] | null;
  onRegenerate: (anchorId: string) => void;
  regenerateState: { kind: string };
  onViewVariation: (variationId: string, siblings: PreviewSibling[]) => void;
}) {
  const { anchor, isHomepage } = props;
  const hasPublication = props.publicationItems !== null;
  const baseColSpan = isHomepage ? 4 : 3;

  return (
    <>
      <TableRow>
        <TableCell>
          {anchor.anchorText}
          {anchor.generalTopic && (
            <Typography variant="caption" color="text.secondary" display="block">
              {anchor.generalTopic}
            </Typography>
          )}
        </TableCell>
        {isHomepage && (
          <TableCell align="right">{anchor.sentences.length}</TableCell>
        )}
        <TableCell>{anchor.status}</TableCell>
        <TableCell>
          {!hasPublication && (anchor.status === "completed" || anchor.status === "failed") && (
            <IfPermission permission="generation.manage">
              <Button
                size="small"
                variant="outlined"
                onClick={() => props.onRegenerate(anchor.id)}
                disabled={props.regenerateState.kind === "loading"}
              >
                {props.regenerateState.kind === "loading" ? "…" : "Перегенерировать"}
              </Button>
            </IfPermission>
          )}
        </TableCell>
      </TableRow>
      {isHomepage
        ? anchor.sentences.map((sentence) => (
            <SentenceBand
              key={sentence.id}
              sentence={sentence}
              publicationItems={hasPublication ? (props.publicationItems as PublicationItemInfo[]) : null}
              colSpan={baseColSpan}
            />
          ))
        : anchor.articles.map((article, index) => (
            <ArticleBand
              key={index}
              article={article}
              publicationItems={hasPublication ? (props.publicationItems as PublicationItemInfo[]) : null}
              onViewVariation={props.onViewVariation}
            />
          ))}
    </>
  );
}
